var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,0C7.2,0,0,7.2,0,16s7.2,16,16,16s16-7.2,16-16S24.8,0,16,0z M12.9,6.7c0.5-0.2,2.3-0.6,2.7-0.2 c0.5,0.4,0.2,6.6,0.2,7.2c0,0.6-0.3,1-0.8,1c-0.5,0-4.4-6-4.4-6.5S11.8,7.1,12.9,6.7z M8.8,17.1c0-1,0.2-2.5,0.7-2.5 c0.5-0.1,3.2,1.3,3.2,1.3s1.5,0.8,1.5,1.3c0,0.5-0.5,0.8-1.1,1c-0.5,0.2-3.2,1.2-3.2,1.2S8.7,20,8.8,17.1z M15.9,24.7 c-0.1,1-1.3,0.7-2.4,0.2c-1.1-0.5-1.9-0.9-1.9-1.4c0-0.5,1.5-2.2,1.9-2.6c0.4-0.5,1.1-1.7,1.7-1.7c0.7,0.1,0.7,1.2,0.7,1.5 S15.9,23.7,15.9,24.7z M20.7,11.1c0.7,0,2.4,2.8,2.4,3.6c-0.1,0.8-2.9,1.4-3.8,1.6c-0.9,0.2-1.3,0.2-1.6-0.2 C17.2,15.2,20.3,11.1,20.7,11.1z M22.2,22.3c-0.4,0.7-1.3,1.5-1.7,1.5c-0.4,0-0.7-0.6-0.7-0.6s-1.3-2.3-1.7-2.9 c-0.4-0.7-0.6-1.4-0.2-1.8c0.6-0.7,3.7,0.9,4.3,1.1c0.6,0.2,0.8,0.4,0.8,0.8C23,20.8,22.6,21.6,22.2,22.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYelp);
export default __webpack_public_path__ + "static/media/Yelp.3afa85646980fb568ef80dacd7713cda.svg";
export { ForwardRef as ReactComponent };